const PAGE_SIZE = 200;
const MAX_PAGES = 100;

export const fetchAllPages = async (fetchPage) => {
  let all_items = [];
  let page = 0;
  let total = Infinity;

  while (all_items.length < total && page < MAX_PAGES) {
    const { items, size } = await fetchPage(page, PAGE_SIZE);
    if (!items || !items.length) break;

    all_items = all_items.concat(items);
    total = size ?? all_items.length;
    page += 1;
  }

  return all_items;
};

export const DAY_MS = 24 * 60 * 60 * 1000;
export const SIX_MONTHS_DAYS = 180;
const AT_RISK_WINDOW_DAYS = 5;
const ONE_MONTH_DAYS = 30;
const THREE_MONTHS_DAYS = 90;

export const computeSubscriptionStatus = (expires_at) => {
  if (!expires_at) return null;

  const days_since_expiry = (Date.now() - new Date(expires_at).getTime()) / DAY_MS;

  if (days_since_expiry < -AT_RISK_WINDOW_DAYS) return 'active';
  if (days_since_expiry < AT_RISK_WINDOW_DAYS) return 'at_risk';
  if (days_since_expiry < ONE_MONTH_DAYS) return 'critical';
  if (days_since_expiry < THREE_MONTHS_DAYS) return 'paused';
  if (days_since_expiry < SIX_MONTHS_DAYS) return 'churned';
  return null;
};

export const mostRecentSubscriptionPerTenant = (subscriptions = []) => {
  const by_tenant = new Map();

  const recencyOf = (subscription) =>
    subscription.time_stamp ??
    new Date(subscription.purchased_at || subscription.created_on || 0).getTime();

  subscriptions.forEach((subscription) => {
    const timestamp = recencyOf(subscription);
    const existing = by_tenant.get(subscription.tenant_id);
    const existing_timestamp = existing ? recencyOf(existing) : -Infinity;

    if (timestamp > existing_timestamp) {
      by_tenant.set(subscription.tenant_id, subscription);
    }
  });

  return Array.from(by_tenant.values());
};
